import { mergeTranslationResources, sharedTranslationResources } from './base.js'
import en from './apps/finetune-web/locales/en.json' with { type: 'json' }
import zh from './apps/finetune-web/locales/zh.json' with { type: 'json' }
import ja from './apps/finetune-web/locales/ja.json' with { type: 'json' }
import ko from './apps/finetune-web/locales/ko.json' with { type: 'json' }
import fr from './apps/finetune-web/locales/fr.json' with { type: 'json' }

type AppTranslationResources = Record<string, { translation: Record<string, unknown> }>

const localResources = {
  en: { translation: en },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
  fr: { translation: fr },
}

export const finetuneTranslationResources: AppTranslationResources = mergeTranslationResources(sharedTranslationResources, localResources) as AppTranslationResources